var window=global;var $CLJS=require("./cljs_env.js");
'use strict';var Mga=require("moment-timezone");module.exports=Mga;